import type { RouteConfig } from 'vue-router';
import StandardLayout from '@/layouts/standard-layout.vue';
import type { CreateElement } from 'vue';
import { backToBeforeOpenExternalUrl } from '@/shared/util';
import colorfulBackgroundImage from '@/assets/img/bg-colorful.png';

export default [
  {
    path: '/misc',
    component: StandardLayout,
    meta: {
      hasNavBarLayout: true,
    },
    children: [
      /**
       * 客服
       */
      {
        path: '/misc/contacts',
        meta: {
          background: '#F3F6F7',
          title: '联系客服',
        },
        component: () => import('@/views/misc/contacts/index.vue'),
      },
      /**
       * 在线客服-重定向到智齿
       */
      {
        path: '/misc/contacts/chat',
        meta: {
          background: '#F3F6F7',
          title: '联系客服',
          customNavBar: true,
        },
        component: () => import('@/views/misc/contacts/chat.vue'),
      },
      {
        path: '/misc/contacts/videoPlay',
        meta: {
          background: '#F3F6F7',
          title: '指引视频',
        },
        component: () => import('@/views/misc/contacts/videoPlay.vue'),
      },
      /**
       * 关注微信
       */
      {
        path: '/misc/follow-wechat',
        meta: {
          excludeLogin: true,
          background: '#448AFF',
          title: '关注微信',
        },
        component: () => import('@/views/misc/follow-wechat.vue'),
      },
      /**
       * 关注企业微信
       */
      {
        path: '/misc/work-wechat',
        meta: {
          title: '优质客户专属服务',
        },
        component: () => import('@/views/misc/work-wechat.vue'),
      },
      /**
       * 营业执照
       * 目前仅用于宜享花APP
       */
      {
        path: '/misc/business-license',
        meta: {
          excludeLogin: true,
          background: '#fff',
          title: '营业执照',
        },
        component: () => import('@/views/misc/business-license.vue'),
      },
      /**
       * 结清证明/合同
       */
      {
        path: '/misc/settle-contract/:type',
        meta: {
          customNavBar: true,
        },
        components: {
          default: () => import('@/views/misc/settle-contract.vue'),
        },
      },
      {
        path: '/misc/affiliate',
        meta: {
          customNavBar: true,
        },
        components: {
          default: () => import('@/views/misc/affiliate.vue'),
        },
      },
      /**
       * 客服问题
       */
      {
        path: '/misc/question',
        meta: {
          excludeLogin: true,
          background: '#F3F6F7',
          title: '联系客服',
        },
        component: () => import('@/views/misc/question.vue'),
      },
      /**
       * 反诈提醒
       * 目前仅用于宜享花APP
       */
      {
        path: '/misc/anti-fraud',
        meta: {
          excludeLogin: true,
          title: '宜享花反诈骗提示',
          background: '#accfff',
        },
        component: () => import('@/views/misc/anti-fraud.vue'),
      },
      /**
       * 注销
       */
      {
        path: '/misc/close-account',
        meta: {
          title: '注销账户',
          background: '#fff',
          customNavBar: true,
        },
        component: () => import('@/views/misc/close-account/index.vue'),
      },
      /**
       * 暂时关闭账户
       */
      {
        path: '/misc/close-account/temporary-close',
        meta: {
          title: '关闭账户',
          background: '#fff',
          customNavBar: true,
        },
        component: () => import('@/views/misc/close-account/temporary-close.vue'),
      },
      /**
       * 注销挽留问题
       */
      {
        path: '/misc/close-account/detainment-question',
        meta: {
          title: '注销账户',
          background: '#fff',
        },
        component: () => import('@/views/misc/close-account/detainment-question.vue'),
      },
      /**
       * 注销挽留信
       */
      {
        path: '/misc/close-account/detainment-letter',
        meta: {
          title: '注销账户',
          background: '#6492FC',
        },
        component: () => import('@/views/misc/close-account/detainment-letter.vue'),
      },
      /**
       * 注销挽留权益列表
       */
      {
        path: '/misc/close-account/detainment-rights',
        meta: {
          title: '注销账户',
          background: '#EBF2FF',
        },
        component: () => import('@/views/misc/close-account/detainment-rights.vue'),
      },
      /**
       * 注销登记
       */
      {
        path: '/misc/close-account/check-in',
        meta: {
          title: '注销账户',
          background: '#fff',
          customNavBar: true,
        },
        component: () => import('@/views/misc/close-account/check-in.vue'),
      },
      /**
       * 注销券包
       */
      {
        path: '/misc/close-account/detainment-coupons',
        meta: {
          title: '注销账户',
          background: '#FFE1B6',
          customNavBar: true,
        },
        component: () => import('@/views/misc/close-account/detainment-coupons.vue'),
      },
      /*
       * 逾期不良影响介绍
       */
      {
        path: '/misc/overdue-intro',
        meta: {
          title: '逾期不良影响',
          background: '#F8F9FF',
          excludeLogin: true,
        },
        component: () => import('@/views/misc/overdue-intro/index.vue'),
      },
      /**
       * 项目债转站内信通知-中融国际信托
       */
      {
        path: '/misc/letter',
        meta: {
          title: '通知',
          background: '#fff',
        },
        component: () => import('@/views/misc/project-debt-letter/zrxt.vue'),
      },
      /**
       * 项目债转站内信通知-渤海国际信托
       */
      {
        path: '/misc/letter/bhxt',
        meta: {
          title: '通知',
          background: '#fff',
        },
        component: () => import('@/views/misc/project-debt-letter/bhxt.vue'),
      },
      /**
       * 项目债转站内信通知-国民华通信托
       */
      {
        path: '/misc/letter/gmht',
        meta: {
          title: '通知',
          background: '#fff',
        },
        component: () => import('@/views/misc/project-debt-letter/gmht.vue'),
      },
      /**
       * 项目债转站内信通知-志恒主体
       */
      {
        path: '/misc/letter/zhzt',
        meta: {
          title: '通知',
          background: '#fff',
        },
        component: () => import('@/views/misc/project-debt-letter/zhzt.vue'),
      },
      /**
       * 项目债转站内信通知-海南小贷主体
       */
      {
        path: '/misc/letter/hnxdzt',
        meta: {
          title: '通知',
          background: '#fff',
        },
        component: () => import('@/views/misc/project-debt-letter/hnxdzt.vue'),
      },
      /**
       * 项目债转站内信通知-模版
       */
      {
        path: '/misc/letter/template',
        meta: {
          title: '通知',
          background: '#fff',
        },
        component: () => import('@/views/misc/project-debt-letter/template.vue'),
      },
      /**
       * 项目债转站内信通知-模版v2
       */
      {
        path: '/misc/letter/template/v2',
        meta: {
          title: '通知',
          background: '#fff',
        },
        component: () => import('@/views/misc/project-debt-letter/template-v2.vue'),
      },
      {
        path: '/misc/funds-close-time-detail',
        meta: {
          title: '详情',
          excludeLogin: true,
        },
        component: () => import('@/views/misc/funds-close-time-detail.vue'),
      },
      /*
       * 消保中心
       */
      {
        path: '/misc/consumer-protection',
        meta: {
          title: '消保中心',
          background: '#F8F9FF',
          excludeLogin: true,
          customNavBar: true,
        },
        component: () => import('@/views/misc/consumer-protection.vue'),
      },
      /*
       * 消保中心内容
       */
      {
        path: '/misc/consumer-protection/content',
        meta: {
          title: '消保中心',
          background: '#F8F9FF',
          excludeLogin: true,
        },
        component: () => import('@/views/misc/protection-content.vue'),
      },
      /*
       * 消保中心内容
       */
      {
        path: '/misc/consumer-protection/content2',
        meta: {
          title: '消保中心',
          background: '#F8F9FF',
          excludeLogin: true,
        },
        component: () => import('@/views/misc/consumer-protection-content/content2.vue'),
      },
      /*
       * 消保中心内容
       */
      {
        path: '/misc/consumer-protection/content3',
        meta: {
          title: '消保中心',
          background: '#F8F9FF',
          excludeLogin: true,
        },
        component: () => import('@/views/misc/consumer-protection-content/content3.vue'),
      },
      /**
       * 债权转让协议
       */
      {
        path: '/misc/home-dynamic',
        meta: {
          excludeLogin: true,
          title: '动态专区',
        },
        component: () => import('@/views/misc/home-dynamic.vue'),
      },
      /**
       * 信用报告引导页
       */
      {
        path: '/misc/credit-report-guide',
        meta: {
          title: '资金匹配',
          customNavBar: true,
        },
        component: () => import('@/views/misc/credit-report-guide.vue'),
      },
      /**
       * 借款指南
       * 目前仅用于宜享花APP、小程序
       */
      {
        path: '/misc/loan-guide',
        meta: {
          excludeLogin: true,
          background: '#F5F5F5',
          title: '借款指南',
        },
        component: () => import('@/views/misc/loan-guide.vue'),
      },
      /**
       * 还款指南
       * 目前仅用于宜享花APP、小程序
       */
      {
        path: '/misc/repay-guide',
        meta: {
          excludeLogin: true,
          background: '#F5F5F5',
          title: '还款指南',
        },
        component: () => import('@/views/misc/repay-guide.vue'),
      },
      /**
       * 开票指引
       */
      {
        path: '/misc/invoicing-guide',
        meta: {
          excludeLogin: true,
          background: '#fff',
          title: '开票指引',
        },
        component: () => import('@/views/misc/invoicing-guide.vue'),
      },
      /**
       * 客服对话简版页面
       */
      // {
      //   path: '/misc/customer-service/chat',
      //   meta: {
      //     title: '在线客服',
      //     background: '#F5F5F5',
      //     customNavBar: false,
      //   },
      //   component: () => import('@/views/customer-service/chat/index.vue'),
      // },
      {
        path: '/misc/lending-institution',
        meta: {
          excludeLogin: true,
          background: '#F8F9FF',
          title: '合作金融机构',
          customNavBar: true,
          excludeTracking: true,
        },
        component: () => import('@/views/misc/lending-institution.vue'),
      },
    ],
  },
  /**
   * 了解宜享花
   * 目前仅用于宜享花APP、小程序
   */
  {
    path: '/misc/intro',
    meta: {
      excludeLogin: true,
      background: '#F2F5FF',
      title: '了解宜享花',
    },
    component: () => import('@/views/misc/intro.vue'),
  },
  /**
   * 下载页面
   */
  {
    path: '/misc/download-app',
    meta: {
      excludeLogin: true,
      title: '下载宜享花',
    },
    component: () => import('@/views/misc/download-app.vue'),
  },
  {
    path: '/misc/download-app-for-std',
    redirect: '/misc/download-app-for-std/general',
  },
  /**
   * 下载页
   * 适用于商通贷中下载宜享花APP
   */
  {
    path: '/misc/download-app-for-std/:type',
    meta: {
      excludeLogin: true,
      title: '下载宜享花',
    },
    component: () => import('@/views/misc/download-app-for-std.vue'),
  },
  /**
   * 自动下载页面
   */
  {
    path: '/misc/download-app-auto',
    meta: {
      excludeLogin: true,
      title: '下载宜享花',
    },
    component: () => import('@/views/misc/download-app-auto.vue'),
  },
  /**
   * 腾讯天御验证码
   * 目前仅用于宜享花APP
   */
  {
    path: '/misc/captcha',
    meta: {
      excludeLogin: true,
      title: '验证码',
    },
    component: () => import('@/views/misc/captcha.vue'),
  },
  /**
   * 静默标准授权
   */
  {
    path: '/misc/standard/authorize',
    meta: {
      title: '宜享花',
    },
    component: () => import('@/views/misc/standard-authorize.vue'),
  },
  /**
   * deeplink 唤起APP
   */
  {
    path: '/misc/deeplink',
    meta: {
      excludeLogin: true,
      title: '宜享花',
    },
    component: () => import('@/views/misc/deeplink.vue'),
  },
  /**
   * 天下信用-信用报告上传
   */
  {
    path: '/misc/credit-report/authorize',
    meta: {
      title: '提供报告',
      background: '#fff',
    },
    component: () => import('@/views/misc/credit-report/authorize.vue'),
  },
  /**
   * 天下信用-提额结果
   */
  {
    path: '/misc/credit-report/result',
    meta: {
      title: '提额结果',
      background: '#fff',
    },
    component: () => import('@/views/misc/credit-report/result.vue'),
  },

  /**
   * 后退到打开外部页面之前
   */
  {
    path: '/misc/back-to-before-open-external-url',
    meta: {
      background: '#fff',
      customNavBar: true,
      excludeLogin: true,
    },
    component: {
      beforeCreate() {
        backToBeforeOpenExternalUrl();
      },
      render(h: CreateElement) {
        return h();
      },
    },
  },
  /**
   * 绑定微信公众号
   */
  {
    path: '/misc/bind-wechat',
    meta: {
      excludeLogin: true,
      background: '#fff',
    },
    component: () => import('@/views/misc/bind-wechat/binding.vue'),
  },
  /**
   * 已绑定微信公众号
   */
  {
    path: '/misc/bind-wechat/already',
    meta: {
      excludeLogin: true,
      background: '#f5f5f5',
    },
    component: () => import('@/views/misc/bind-wechat/already-binding.vue'),
  },
  /*
   * 存量协议补签-身份认证页面
   */
  {
    path: '/misc/re-sign-agreement',
    meta: {
      title: '身份认证',
      background: '#F8F9FF',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/re-sign-agreement/authentication.vue'),
  },
  /*
   * 存量协议补签-协议预览页面
   */
  {
    path: '/misc/re-sign-agreement/stock-agreement',
    meta: {
      title: '文件签署',
      background: '#F8F9FF',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/re-sign-agreement/stock-agreement.vue'),
  },
  /**
   * 工单邀请用户发送短信落地页
   */
  {
    path: '/misc/issue-feedback',
    meta: {
      title: '问题反馈',
      canBack: false,
      customNavBar: false,
      background: '#F8F9FF',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/issue-feedback/index.vue'),
  },
  /**
   * 工单邀请用户发送短信提交结果页
   */
  {
    path: '/misc/issue-feedback/result',
    meta: {
      title: '问题反馈',
      customNavBar: false,
      background: '#F8F9FF',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/issue-feedback/result.vue'),
  },
  /**
   * 下载合同，提供给渠道方使用
   */
  {
    path: '/misc/download-contract',
    meta: {
      title: '下载合同',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/download-contract.vue'),
  },
  /**
   * 强核身身份验证
   */
  {
    path: '/misc/enforce-verify',
    meta: {
      title: '本人身份验证',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/enforce-verify/index.vue'),
  },
  /**
   * 强核身身份验证结果
   */
  {
    path: '/misc/enforce-verify/result',
    meta: {
      title: '验证结果',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/enforce-verify/result.vue'),
  },
  /**
   * 强核身身份验证链接失效
   */
  {
    path: '/misc/enforce-verify/invalid',
    meta: {
      title: '链接失效',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/enforce-verify/invalid.vue'),
  },
  /**
   * 强核身身份验证-受托人验证
   */
  {
    path: '/misc/enforce-verify/trustee',
    meta: {
      title: '非本人委托验证',
      excludeLogin: true,
      background: `#F2F4F7 url(${colorfulBackgroundImage}) no-repeat 0 0/100% auto`,
    },
    component: () => import('@/views/misc/enforce-verify/trustee.vue'),
  },
  /**
   * 强核身身份验证-受托人验证结果
   */
  {
    path: '/misc/enforce-verify/trustee/result',
    meta: {
      title: '验证结果',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/enforce-verify/trustee-result.vue'),
  },
  /**
   * 消保-客户个人征信异议申诉入口
   */
  {
    path: '/misc/credit-dispute',
    meta: {
      title: '个人征信异议申诉',
      excludeLogin: true,
      background: `#F2F4F7 url(${colorfulBackgroundImage}) no-repeat 0 0/100% auto`,
    },
    component: () => import('@/views/misc/credit-dispute/index.vue'),
  },
  /**
   * 消保-客户个人征信异议审核中
   */
  {
    path: '/misc/application-auditing',
    meta: {
      title: '申诉审核中',
      excludeLogin: true,
    },
    component: () => import('@/views/misc/credit-dispute/application-auditing.vue'),
  },
  /**
   * 消保-用户涉诈案例举报中心
   */
  {
    path: '/misc/fraud-report/report-center',
    meta: {
      title: '举报中心',
    },
    component: () => import('@/views/misc/fraud-report/report-center.vue'),
  },
  /**
   * 消保-诈骗举报
   */
  {
    path: '/misc/fraud-report/form',
    meta: {
      title: '诈骗举报',
      background: `#F2F4F7 url(${colorfulBackgroundImage}) no-repeat 0 0/100% auto`,
    },
    component: () => import('@/views/misc/fraud-report/fraud-report-form.vue'),
  },
  /**
   * 消保-诈骗举报结果
   */
  {
    path: '/misc/fraud-report/result',
    meta: {
      title: '举报结果',
    },
    component: () => import('@/views/misc/fraud-report/fraud-report-result.vue'),
  },
  /**
   * 消保-客服服务进度
   */
  {
    path: '/misc/customer-service',
    meta: {
      title: '客服服务进度',
      background: '#F2F4F7',
      customNavBar: false,
    },
    component: () => import('@/views/misc/customer-service/index.vue'),
  },
  /**
   * 消保-客服服务进度
   */
  {
    path: '/misc/customer-service/detail',
    meta: {
      title: '服务工单详情',
      background: '#F2F4F7',
      customNavBar: false,
    },
    component: () => import('@/views/misc/customer-service/detail.vue'),
  },
  /**
   * 消保-黑产举报
   */
  {
    path: '/misc/black-industry-report',
    meta: {
      title: '黑产举报',
      background: `#F2F4F7 url(${colorfulBackgroundImage}) no-repeat 0 0/100% auto`,
    },
    component: () => import('@/views/misc/black-industry-report/index.vue'),
  },
] as RouteConfig[];
